import { createPortal } from 'react-dom';
import { Loader2 } from 'lucide-react';

interface FullScreenLoaderProps {
  isVisible: boolean;
  message?: string;
  subMessage?: string;
}

export default function FullScreenLoader({
  isVisible,
  message = 'Processing...',
  subMessage,
}: FullScreenLoaderProps) {
  if (!isVisible) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-slate-950/90 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4 p-8 rounded-2xl bg-slate-900/80 border border-slate-700/50">
        <Loader2 size={48} className="text-indigo-500 animate-spin" />
        <div className="text-center">
          <p className="text-lg font-medium text-slate-200">{message}</p>
          {subMessage && <p className="text-sm text-slate-400 mt-1">{subMessage}</p>}
        </div>
      </div>
    </div>,
    document.body
  );
}
